import { render } from "./EventRegComponent.vue?vue&type=template&id=8d402b60&scoped=true&ts=true"
import script from "./EventRegComponent.vue?vue&type=script&lang=ts"
export * from "./EventRegComponent.vue?vue&type=script&lang=ts"

import "./EventRegComponent.vue?vue&type=style&index=0&id=8d402b60&scoped=true&lang=css"
import "./EventRegComponent.vue?vue&type=style&index=1&id=8d402b60&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d402b60"]])

export default __exports__